import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import { LanguageContext } from '../App';
import { FIRM_INFO } from '../constants/firmInfo';
import { useAuth } from '../context/AuthContext';
import { SUPPORTED_LANGUAGES } from '../utils/language';
import { translations } from '../utils/translations';

const LANGUAGE_LABELS = {
  en: 'Language',
  es: 'Idioma',
  ht: 'Lang',
  pt: 'Idioma',
  zh: '语言',
};

const CHANGE_LANGUAGE_ARIA_LABELS = {
  en: 'Change language',
  es: 'Cambiar idioma',
  ht: 'Chanje lang',
  pt: 'Mudar idioma',
  zh: '更改语言',
};

function Header() {
  const navigate = useNavigate();
  const { language, setLanguage } = useContext(LanguageContext);
  const t = translations[language] || translations.en;
  const { user, intakeComplete, loading } = useAuth();
  const [hovered, setHovered] = useState(false);
  const languageLabel = LANGUAGE_LABELS[language] || LANGUAGE_LABELS.en;
  const changeLanguageAriaLabel =
    CHANGE_LANGUAGE_ARIA_LABELS[language] || CHANGE_LANGUAGE_ARIA_LABELS.en;

  const handleCallNow = () => {
    window.location.href = `tel:${FIRM_INFO.phone}`;
  };

  const handleLogoClick = () => {
    if (loading) return;

    if (!user) {
      navigate('/');
      return;
    }

    if (!intakeComplete) {
      navigate('/intake');
      return;
    }

    navigate('/dashboard');
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <div
            onClick={handleLogoClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onTouchStart={() => setHovered(true)}
            onTouchEnd={() => setHovered(false)}
            style={{
              cursor: 'pointer',
              transform: hovered ? 'scale(1.03)' : 'scale(1)',
              transition: 'all 0.15s ease',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <img src="/cta-logo.png" alt={FIRM_INFO.name} className="header-logo" />
            <span className="firm-name">{FIRM_INFO.name}</span>
          </div>
        </div>
        <div className="header-language">
          <label className="header-language-label" htmlFor="header-language-select">
            <span className="header-language-label-badge" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                className="header-language-label-icon"
                focusable="false"
                aria-hidden="true"
              >
                <path
                  d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18Zm6.92 8h-3.07a14.6 14.6 0 0 0-1.15-4.16A7.03 7.03 0 0 1 18.92 11ZM12 5.05c.85 1.01 1.7 2.83 2.07 5.95H9.93C10.3 7.88 11.15 6.06 12 5.05ZM9.3 6.84A14.6 14.6 0 0 0 8.15 11H5.08A7.03 7.03 0 0 1 9.3 6.84ZM5.08 13h3.07c.16 1.49.56 2.92 1.15 4.16A7.03 7.03 0 0 1 5.08 13Zm4.85 0h4.14c-.37 3.12-1.22 4.94-2.07 5.95c-.85-1.01-1.7-2.83-2.07-5.95Zm4.77 4.16c.59-1.24.99-2.67 1.15-4.16h3.07a7.03 7.03 0 0 1-4.22 4.16Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span>{languageLabel}</span>
          </label>
          <div className="header-language-field">
            <span className="header-language-field-icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                className="header-language-field-icon-svg"
                focusable="false"
                aria-hidden="true"
              >
                <path
                  d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0-18Zm6.92 8h-3.07a14.6 14.6 0 0 0-1.15-4.16A7.03 7.03 0 0 1 18.92 11ZM12 5.05c.85 1.01 1.7 2.83 2.07 5.95H9.93C10.3 7.88 11.15 6.06 12 5.05ZM9.3 6.84A14.6 14.6 0 0 0 8.15 11H5.08A7.03 7.03 0 0 1 9.3 6.84ZM5.08 13h3.07c.16 1.49.56 2.92 1.15 4.16A7.03 7.03 0 0 1 5.08 13Zm4.85 0h4.14c-.37 3.12-1.22 4.94-2.07 5.95c-.85-1.01-1.7-2.83-2.07-5.95Zm4.77 4.16c.59-1.24.99-2.67 1.15-4.16h3.07a7.03 7.03 0 0 1-4.22 4.16Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <select
              id="header-language-select"
              className="header-language-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              aria-label={changeLanguageAriaLabel}
            >
              {SUPPORTED_LANGUAGES.map((languageCode) => (
                <option key={languageCode} value={languageCode}>
                  {t.header.languageOptions[languageCode]}
                </option>
              ))}
            </select>
            <span className="header-language-caret" aria-hidden="true">▾</span>
          </div>
        </div>
        <button className="call-button" onClick={handleCallNow}>
          {t.buttons.callNow}
        </button>
      </div>
    </header>
  );
}

export default Header;
